"use client";

import Image from "next/image";
import React from "react";

import { CaseStudyData } from "../../data/case-studies/types";

interface CaseStudyWorkbenchesProps {
  caseStudy: CaseStudyData;
}

export function CaseStudyWorkbenches({ caseStudy }: CaseStudyWorkbenchesProps) {
  if (caseStudy.workbenches.length === 0) return null;

  return (
    <section className="py-20 md:py-28 border-b border-white/[0.08]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {/* Section Header */}
        <div className="mb-12 space-y-3">
          <span className="font-mono text-xs text-cyan-400 uppercase tracking-wider">
            Product Workbenches
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white">
            Live Interface & Inspection Workflows
          </h2>
        </div>

        {/* 2-Column High-Contrast Software Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {caseStudy.workbenches.map((wb, idx) => (
            <div key={idx} className="space-y-4">
              <div className="rounded-3xl overflow-hidden bg-zinc-950 border border-white/15 shadow-2xl group hover:border-white/30 transition-all duration-300">
                <div className="relative w-full aspect-[4/3]">
                  <Image
                    src={wb.image}
                    alt={wb.alt}
                    fill
                    className="object-cover"
                    sizes="(max-width: 768px) 100vw, 50vw"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <h4 className="text-xl font-bold text-white tracking-tight">
                  {wb.title}
                </h4>
                <p className="text-sm text-slate-300 font-light leading-relaxed">
                  {wb.caption}
                </p>

                {wb.callouts && wb.callouts.length > 0 && (
                  <div className="flex flex-wrap gap-2 pt-2">
                    {wb.callouts.map((callout, cIdx) => (
                      <span
                        key={cIdx}
                        className="text-[11px] font-mono text-zinc-400 bg-white/5 px-2.5 py-1 rounded-full border border-white/10"
                      >
                        {callout}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
